import styled from 'styled-components';

export const StyledProfile = styled('div')`
  .content {
    font-family: ${(props) => props.theme.fontText};
    display: flex;
    min-width: 221px;
    min-height: 63px;
    gap: 18px;
    align-items: center;

    .info {
      display: flex;
      flex-direction: column;
      overflow: hidden;
      max-height: 110px;
      max-width: 350px;

      .farm-name,
      .role {
        font-weight: 400;
        font-size: 14px;
        line-height: 20px;
        max-height: 36px;
        overflow: hidden;
      }

      .contact-name {
        font-weight: 700;
        font-size: 18px;
        line-height: 26px;
      }
    }
  }
`;
